import ListPRSeleksiVendor from './ListPRSeleksiVendor'

export default ListPRSeleksiVendor